import { Link } from "react-router-dom";
import MarketingLayout from "@/components/MarketingLayout";
import { SEO } from "@/components/shared/SEO";

const LAST_UPDATED = "April 5, 2026";

export default function LegalDocumentPage({ title, description, canonical, children }) {
  return (
    <MarketingLayout>
      <SEO title={title} description={description} canonical={canonical} />
      <article className="pt-28 px-6 max-w-3xl mx-auto pb-24">
        <header className="mb-10 border-b border-white/[0.06] pb-8">
          <h1 className="text-3xl font-display font-bold tracking-tight text-foreground">{title}</h1>
          <p className="mt-2 text-sm text-muted-foreground">Last updated: {LAST_UPDATED}</p>
        </header>
        <div className="text-[15px] leading-relaxed text-muted-foreground space-y-6 [&_h2]:text-lg [&_h2]:font-display [&_h2]:font-bold [&_h2]:text-foreground [&_h2]:mt-10 [&_h2]:mb-3 [&_h3]:text-base [&_h3]:font-semibold [&_h3]:text-foreground [&_h3]:mt-6 [&_h3]:mb-2 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:space-y-2 [&_p]:mb-0">
          {children}
        </div>
        <nav className="mt-14 pt-8 border-t border-white/[0.06] text-sm text-muted-foreground">
          <p className="mb-2 font-medium text-foreground">Related</p>
          <ul className="flex flex-wrap gap-x-4 gap-y-1">
            <li>
              <Link to="/privacy" className="text-lime-400 hover:underline">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/terms" className="text-lime-400 hover:underline">
                Terms of Service
              </Link>
            </li>
            <li>
              <Link to="/gdpr" className="text-lime-400 hover:underline">
                GDPR &amp; EU rights
              </Link>
            </li>
          </ul>
        </nav>
      </article>
    </MarketingLayout>
  );
}
